import { createAction, props } from '@ngrx/store';

/**
 * Navigate to Patient step
 */
export const navigateToPatientStep = createAction(
  '[Rapid Reco] Navigate to Patient step',
  props<{ isFromAllowanceParamPresent: boolean }>(),
);
/**
 * Navigate to Share Recommendation step
 */
export const navigateToShareRecommendation = createAction(
  '[Rapid Reco] Navigate to Share Recommendation step',
  props<{ includePetProfileIntoPOLetter: boolean }>(),
);

/**
 * Track the Pet Profile (if any) and Selected Products
 */
export const trackNutritionalRecommendation = createAction('[Rapid Reco] Track Nutritional Recommendation');
